import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const useCustomHook = () => {
  const navigate = useNavigate();

  const [typeOfMethod, setTypeOfMethod] = useState(
    navigate.location?.state?.group?.multiConfirmationSrv?.guildSrv ? 'guild' : 'wallet',
  ); // wallet or credit
  const [expireDate, setExpireDate] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [name, setName] = useState(null);

  const [rowsWithError, setRowsWithError] = useState([]);
  const [isResultErrorsOpen, setIsResultErrorsOpen] = useState(false);

  const [guilds, setGuilds] = useState([]);
  const [usages, setUsages] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState([]);

  const [usageEnabled, setUsageEnabled] = useState(false);
  const [periodicEnabled, setPeriodicEnabled] = useState(false);
  const [usageLimitsEnabled, setUsageLimitsEnabled] = useState(false);
  const [usagePeriodEnabled, setUsagePeriodEnabled] = useState(false);

  const [foundUser, setFoundUser] = useState(null);

  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);

  const [activeStep, setActiveStep] = useState(0);

  return {
    expireDate,
    setExpireDate,
    startDate,
    setStartDate,
    name,
    setName,
    rowsWithError,
    setRowsWithError,
    isResultErrorsOpen,
    setIsResultErrorsOpen,
    guilds,
    setGuilds,
    usages,
    setUsages,
    selectedProducts,
    setSelectedProducts,
    usageEnabled,
    setUsageEnabled,
    periodicEnabled,
    setPeriodicEnabled,
    usageLimitsEnabled,
    setUsageLimitsEnabled,
    usagePeriodEnabled,
    setUsagePeriodEnabled,
    foundUser,
    setFoundUser,
    loading,
    setLoading,
    submitting,
    setSubmitting,
    isConfirmModalOpen,
    setIsConfirmModalOpen,
    activeStep,
    setActiveStep,
    typeOfMethod,
    setTypeOfMethod,
  };
};

export default useCustomHook;
